// extracted by mini-css-extract-plugin
export default {"container":"body_container__278aA","urbaniaLogo":"body_urbaniaLogo__3tTho","draw":"body_draw__OtyB4"};